import React, { useState } from "react";
// r redux
import { useSelector } from "react-redux";
// mui
import { Button } from "@mui/material";
// axios
import EnhancedAxios from "../../api/EnhancedAxios";
// alerts
import {
    successAlert,
    askForConfirmationAlert,
    errorAlert,
} from "../../utils/alerts";
import { getUserRole } from "../../utils/roles/getUserRole";

const DeleteJoinRequest = ({ id, name }) => {
    const userToken = useSelector((state) => state.userToken);
    const userData = useSelector((state) => state.userData);
    const role = getUserRole(userData);
    const [isDeleted, setIsDeleted] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const deleteUser = () => {
        setSubmitting(true);
        EnhancedAxios(null, userToken)
            .delete(`/${role}/driver-forms/${id}`)
            .then((res) => {
                successAlert("تم حذف طلب المتسخدم");
                setIsDeleted(true);
            })
            .catch((error) => errorAlert(error))
            .finally(() => setSubmitting(false));
    };
    const confirmDeleting = () => {
        askForConfirmationAlert(
            `هل أنت متأكد انك تريد حذف  طلب السائق "${name}"`,
            deleteUser
        );
    };
    return (
        <Button
            color="error"
            variant="outlined"
            onClick={confirmDeleting}
            disabled={isDeleted}
        >
            {isDeleted ? "تم الحذف" : "حذف"}
        </Button>
    );
};

export default DeleteJoinRequest;
